let isSkeletonPreviewPage = document.querySelector('.skeleton-preview');

if (isSkeletonPreviewPage) {
    function updateCoordinates(section, elements) {
        let controls = section.querySelectorAll('.skeleton-preview-section-input');
        let left = section.querySelector('.left');
        let top = section.querySelector('.top');

        //Set initial coordinates in inputs
        [].forEach.call(elements, function (el) {
            left.value = parseInt(el.style.left, 10);
            top.value = parseInt(el.style.top, 10);
        });

        //Updates positioning for elements
        function updateValues() {
            [].forEach.call(elements, function (el) {
                el.style.left = left.value + '%';
                el.style.top = top.value + '%';
            });
        }

        //Listens for input updates
        [].forEach.call(controls, function (input) {
            input.addEventListener('keyup', function () {
                updateValues();
            });
        });
    }

    //List
    let listSection = document.getElementById('list');
    let listEls = document.querySelectorAll('.skeleton-list');
    updateCoordinates(listSection, listEls);

    //Header
    let headerSection = document.getElementById('header');
    let headerEl = document.querySelectorAll('.skeleton-header');
    updateCoordinates(headerSection, headerEl);

    //Dots - need different code b/c there are many, different coordinates for these elements
    function updateDotCoordinates() {
        let dotsSection = document.getElementById('dots');
        let controls = dotsSection.querySelectorAll('.skeleton-preview-section-input');
        let left = dotsSection.querySelector('.left');
        let top = dotsSection.querySelector('.top');
        let allDots = document.querySelectorAll('.skeleton-dot');

        //Set initial dot coordinates in inputs
        let initialActiveDot = document.querySelector('.skeleton-dot.active');
        left.value = parseInt(initialActiveDot.style.left, 10);
        top.value = parseInt(initialActiveDot.style.top, 10);

        //When input gets updated, update active dot coordinates
        [].forEach.call(controls, function (input) {
            input.addEventListener('keyup', function () {
                let activeDot = document.querySelector('.skeleton-dot.active');
                activeDot.style.left = left.value + '%';
                activeDot.style.top = top.value + '%';
            });
        });

        //When a new dot is made active, update the inputs with that dot's coordinates
        [].forEach.call(allDots, function (dot) {
            dot.addEventListener('click', function () {
                left.value = parseInt(dot.style.left, 10);
                top.value = parseInt(dot.style.top, 10);
            });
        });
    }
    updateDotCoordinates();
}